<template>
<div class="address-usa-question">
  <div>
    <v-dialog v-model="showInvalid" max-width="400">
      <v-card>
        <v-card-title class="headline">
          Invalid Address
        </v-card-title>
        <v-card-text>
          <p class="full-address">{{fullAddress}}</p>
          <br>
          Sorry, that's not a valid address!
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <!-- <v-btn color="caution" text @click="submitInvalid">
            Submit Anyways
          </v-btn>
          <v-spacer></v-spacer> -->
          <v-btn color="primary" text @click="showInvalid = false">
            Edit Address
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showOptions" max-width="400">
      <v-card>
        <v-card-title class="headline">
          Ambiguous Address
        </v-card-title>
        <v-card-text>
          Select which address you'd like to use, or cancel to edit it yourself.
          <v-list>
            <v-list-item color="primary" three-line v-for="option in options" :key="option"
              @click="submitOption(option)">
              <v-list-item-content>
                <v-list-item-subtitle v-html="option" class="full-address">
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showOptions = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <img v-if="node.question.image !== null" :src="node.question.image" class="question-image" />
    <p v-if="node.prompt !== null">{{node.prompt}}</p>
    <div v-html="node.question.instructions"></div>
    <v-text-field
      id="first-name-input"
      v-model="firstName"
      outlined
      label="First Name"
      autocomplete="given-name"
    ></v-text-field>
    <v-text-field
      id="last-name-input"
      v-model="lastName"
      outlined
      label="Last Name"
      autocomplete="family-name"
    ></v-text-field>
    <v-textarea
      id="address-input"
      v-model="address"
      outlined
      label="Street Address"
      rows="2"
      autocomplete="address-line1"
    ></v-textarea>
    <v-text-field
      id="city-input"
      v-model="city"
      outlined
      label="City"
      autocomplete="address-level2"
    ></v-text-field>
    <v-combobox
      id="state-input"
      :items="this.states"
      v-model="state"
      outlined
      label="State"
      name="state"
      autocomplete="address-level1"
    ></v-combobox>
    <v-text-field
      id="zip-input"
      v-model="zip"
      outlined
      label="ZIP Code"
      autocomplete="postal-code"
    ></v-text-field>
  </div>
  <div class="buttons">
    <v-btn
      class="submit-button"
      :disabled="!isValidSelection()"
      color="primary"
      @click="onAnswerQuestion">
      {{ submitButton }}
    </v-btn>
    <v-btn
      v-if="node.skippable"
      class="submit-button"
      color="secondary"
      @click="onSkipQuestion">
      {{ skipButton }}
    </v-btn>
  </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AddressUSAQuestion',
  data() {
    return {
      isVerifying: false,
      showInvalid: false,
      showOptions: false,
      fullAddress: '',
      options: null,
      firstName: null,
      lastName: null,
      address: null,
      city: null,
      state: null,
      zip: null,
      states: [
        'Alabama', 'Alaska', 'American Samoa', 'Arizona',
        'Arkansas', 'California', 'Colorado', 'Connecticut',
        'Delaware', 'District of Columbia', 'Federated States of Micronesia',
        'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho',
        'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
        'Louisiana', 'Maine', 'Marshall Islands', 'Maryland',
        'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
        'Missouri', 'Montana', 'Nebraska', 'Nevada',
        'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
        'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio',
        'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico',
        'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee',
        'Texas', 'Utah', 'Vermont', 'Virgin Island', 'Virginia',
        'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
      ],
    };
  },
  methods: {
    isValidSelection() {
      return (this.firstName !== null && this.firstName.length > 0
      && this.lastName !== null && this.lastName.length > 0
      && this.address !== null && this.address.length > 0
      && this.city !== null && this.city.length > 0 && this.state != null
      && this.zip !== null && this.zip.length > 0 && !this.isVerifying);
    },
    onAnswerQuestion() {
      const apiURL = process.env.VUE_APP_API_URL;
      const payload = {
        address: this.address,
        city: this.city,
        state: this.state,
        zip: this.zip,
      };
      this.fullAddress = `${this.address}\n${this.city}, ${this.state} ${this.zip}`;
      this.isVerifying = true;

      axios.post(`${apiURL}api/usaddress/`, payload)
        .then((response) => {
          this.options = response.data;
          this.isVerifying = false;

          if (this.options.length === 0) {
            this.showInvalid = true;
          } else if (this.options.length === 1) {
            this.$emit('answer', { node: this.node, text: `${this.firstName} ${this.lastName}\n${this.options[0]}` });
            this.reset();
          } else {
            this.showOptions = true;
          }
        })
        .catch(() => {
          this.isVerifying = false;
          this.showInvalid = true;
        });
    },
    onSkipQuestion() {
      this.$emit('skip');
    },
    submitInvalid() {
      this.$emit('answer', { node: this.node, text: this.fullAddress });
      this.reset();
    },
    submitOption(option) {
      this.$emit('answer', { node: this.node, text: option });
      this.reset();
    },
    reset() {
      this.isVerifying = false;
      this.showInvalid = false;
      this.showOptions = false;
      this.fullAddress = '';
      this.firstName = null;
      this.lastName = null;
      this.options = null;
      this.address = null;
      this.city = null;
      this.state = null;
      this.zip = null;
    },
  },
  props: {
    node: Object,
    submitButton: String,
    skipButton: String,
  },
  mounted() {
    document.getElementById('first-name-input').focus();
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.address-usa-question {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .question-image {
    display: block;
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
  }
}

.full-address {
  white-space: pre;
  font-weight: bold;
}

@media (min-width: $breakpoint-tablet) {
  .text-question {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
